<template>
	<div style="width: 100%;height: 100%;">
		<div style="width: 100%;background-color: #fff;">
            <LayoutHeader />
		</div>
		<div style="width: 100%;background-color: #fff;margin-bottom: 40px;">
			<div class="floatBox">
				<div class="textBox">
					<div class="text">找回密码</div>
				</div>
				<div class="midBox">
					<div class="midFloatBox">
<!--						<div class="breadBox">-->
<!--							<a-breadcrumb>-->
<!--								<a-breadcrumb-item-->
<!--									@click="this.$router.push('/')">首页</a-breadcrumb-item>-->
<!--								<a-breadcrumb-item style="font-size: 14px;">找回密码</a-breadcrumb-item>-->
<!--							</a-breadcrumb>-->
<!--						</div>-->

						<div class="tabBox">
							<a-form class="login-form" ref="ruleForm" layout="horizontal" :model="form" :rules="rules">

                                <template v-if="$route.query.id==1">
                                    <a-form-item :label-col="{ style: 'width:160px' }" name="companyName" label="企业名称">
                                        <a-input size="large" style="width:100%;position:relative" v-model:value="form.companyName" placeholder="请输入企业名称">
                                        </a-input>
                                    </a-form-item>

                                    <a-form-item  :label-col="{ style: 'width:160px' }" name="oraganizationCode" label="统一社会信用代码">
                                        <a-input @blur="subCompanyCode" size="large" style="width:100%;position:relative" v-model:value="form.oraganizationCode" placeholder="请输入统一社会信用代码">
                                        </a-input>
                                    </a-form-item>

                                    <a-form-item :label-col="{ style: 'width:160px' }" name="phoneNumber" label="预留手机号">
                                        <div style="display: flex;align-items: center;">
                                            <div style="font-size: 16px;" v-if="form.phoneNumber">{{form.phoneNumber.substring(0,3)}}****{{form.phoneNumber.substring(7,11)}}</div>
                                            <span
                                                style="margin-left: 20px;border: 1px #8b8b8b solid;padding: 3px;border-radius: 5px"
                                                v-if="form.phoneNumber"
                                            >
                                            <a-botton style="cursor: pointer;" @click="getPhoneCode()">{{ codeBtnWord }}</a-botton>
                                         </span>
                                            <span style="font-size: 14px;color:#ff7173;margin-left: 10px;">(如要变更手机号，请联系管理员 0353-2292730)</span>
                                        </div>
                                        <!--									<a-input size="large" style="width:100%;position:relative" v-model:value="form.phoneNumber" placeholder="请输入手机号">-->
                                        <!--										<template #prefix>-->
                                        <!--											<PhoneOutlined class="tc-gray" />-->
                                        <!--										</template>-->
                                        <!--										<template #addonAfter>-->
                                        <!--											<a-botton style="cursor: pointer;" @click="subPhone()">{{codeBtnWord}}</a-botton>-->
                                        <!--											<div class="codeBtnWordMark" ref="codeBtnWordMarkid" >-->

                                        <!--											</div>-->
                                        <!--										</template>-->
                                        <!--									</a-input>-->
                                    </a-form-item>
                                </template>
                                <Vcode :show="isShow" @success="success" @close="close" @fail='fail'></Vcode>
                                <template v-if="$route.query.id==2">
                                    <a-form-item :label-col="{ style: 'width:160px' }" name="phoneNumber" label="账号">
                                        <a-input size="large" style="width:100%;position:relative"
                                                 v-model:value="form.phoneNumber"
                                                 placeholder="请输入手机号">
                                            <template #prefix>
                                                <PhoneOutlined class="tc-gray"/>
                                            </template>
                                            <template #addonAfter>
                                                <a-botton style="cursor: pointer;" @click="openSliderCode">{{codeBtnWord}}
                                                </a-botton>
                                                <div class="codeBtnWordMark" ref="codeBtnWordMarkid">

                                                </div>
                                            </template>
                                        </a-input>
                                    </a-form-item>
                                </template>

								<a-form-item :label-col="{ style: 'width:160px' }" name="watmal" label="短信验证码">
									<a-input size="large" style="width:100%" v-model:value="form.watmal" placeholder="请输入短信验证码">

									</a-input>
								</a-form-item>

								<a-form-item :label-col="{style:'width:160px'}" name="newpassword" label="新密码">
									<a-input-password size="large" v-model:value="form.newpassword" placeholder="请输入新密码">
										<template #prefix>
											<LockOutlined class="tc-gray" />
										</template>
									</a-input-password>
								</a-form-item>
								<a-form-item :label-col="{style:'width:160px'}" style="position:relative" name="password" label="确认密码">
									<a-input-password @change="getNew" size="large" v-model:value="form.password" placeholder="请再次输入密码">
										<template #prefix>
											<LockOutlined class="tc-gray" />
										</template>
									</a-input-password>
									<ExclamationOutlined v-if="pwOk == false" style="color:red;position:absolute;right:-20px;top:12px" />
									<CheckOutlined v-if="pwOk" style="color:green;position:absolute;right:-20px;top:12px" />
								</a-form-item>


								<div style="overflow: hidden;margin-top: 30px;">
									<div class="btnBB">
										<a-button size="large" style="margin-right: 20px;" @click="goMore('/login', 'user')">返回登录</a-button>
										<a-button size="large" style="width: 130px" type="primary" html-type="submit" :loading="confirmLoading"
											@click="onSubmit">
											确认修改
										</a-button>
									</div>
								</div>
							</a-form>
						</div>
					</div>
				</div>
			</div>
		</div>
		<LayoutFooter />
	</div>
</template>

<script>
import {dictMixin} from "@/mixins";
import {ls} from "@/utils/util"
import {platformName} from "@/config/platformConfig";
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2';
import LayoutHeader from '@/layout/layoutPage/header/LayoutHeaderNew2';
import dataCheck from "@/utils/dataCheck";
import {common, phoneCommon} from "@/api/finance"
import {notification} from "ant-design-vue";
import {file_service, login_mp, register_mp, sys_admin} from "@/api/adminService";
import Vcode from "vue3-puzzle-vcode";

export default {
	name: "index",
	components: {
		LayoutFooter,
        Vcode,
        LayoutHeader
	},
	mixins: [dictMixin],
	data() {
		return {
            isShow:false,
			waitTime: 61,
			all_logo: '',
			dictNames: 'policy_type',
			user: {},
			formState: {
				user: undefined,
			},
			webSiteInfo: {},
			linkData: [],
			pwOk: null,
			companyShow: null,
			optionsRoleTreeList: null,
			optionsMechanIsmTreeList: null,
			optionsBaseTreeTreeList: null,
			optionsTreeList: null,
			codeLength: 4,
			inputvalue: '',
			show: false,
			showerror: false,
			platformName,
			confirmLoading: false,
			codeBtnWord:'获取短信验证码',
			form: {
				phoneNumber: null,
				password: null,
				watmal: null,
				newpassword: null,
                companyName:null,
                oraganizationCode:''
				// captcha: null,
			},
			rules: {
                phoneNumber:[dataCheck.phone,dataCheck.required({msg:"账号不能为空"})],
                companyName: [
                    dataCheck.required({ msg: '企业名称不能为空' }),
                ],
                oraganizationCode: [dataCheck.required({ msg: '统一社会信用代码不能为空' }), dataCheck.oraganizationCode],
				// phoneNumber: [
				// 	dataCheck.required({ msg: '手机号不能为空' }), dataCheck.mobile_phone
				// ],
				newpassword: [
					dataCheck.required({ msg: '密码不能为空' }), dataCheck.password,
				],
				password: [
					dataCheck.required({ msg: '密码不能为空' }),
				],
				watmal: [
					dataCheck.required({ msg: '短信验证码不能为空' }),
				]
				// captcha: [
				//     dataCheck.required({msg: '验证码不能为空'}),
				// ],
			},
			captchaPath: '',
			redirectPath: '/',
		}
	},
	methods: {
        openSliderCode(){
            var valiSome = ['phoneNumber']
            this.$refs.ruleForm
                .validate(valiSome)
                .then(()=>{
                    this.isShow = true
                })
        },
        verifyPhone(){
            var valiSome = ['phoneNumber']
            this.$refs.ruleForm
                .validate(valiSome)
                .then(() => {
                    this.getAction({
                        url: register_mp.verifyUniquePhone,
                        params: {
                            phoneNumber: this.form.phoneNumber
                        }
                    }).then((res) => {
                        if (!res){
                            this.sendPhoneCode()
                        }else{
                            this.$notification.success({
                                message: '账号不存在, 请检查',
                                duration: 10,
                                style: {
                                    width: '400px',
                                    fontWeight: '600',
                                    marginTop: `${10}%`,
                                },
                            })
                        }
                })
            })
        },
        sendPhoneCode() {
            this.$refs.ruleForm
                .validate('phoneNumber')
                .then((value) => {
                    this.postAction({
                            url: phoneCommon.forgetPwd,
                            params: {
                                phone: value.phoneNumber
                            }
                        }
                    ).then((res) => {
                        if (res.code==='500'){
                            notification.warning({
                                message: res.msg,
                                style: {
                                    width: '400px',
                                    fontWeight: '600',
                                    marginLeft: `${-200}%`,
                                    marginTop: `${20}%`,
                                }
                            });
                        }
                        if (res.code == '0') {
                            this.waitTime = (res.msg * 60) + 1
                            this.waitTime--;
                            // this.$refs.codeBtnWordMarkid.style.zIndex = 1
                            this.codeBtnWord = `${this.waitTime}s 后获取`;
                            let timer = setInterval(() => {
                                if (this.waitTime > 1) {
                                    this.waitTime--;
                                    this.codeBtnWord = `${this.waitTime}s 后获取`;
                                } else {
                                    clearInterval(timer);
                                    this.codeBtnWord = "获取短信验证码";
                                    // this.$refs.codeBtnWordMarkid.style.zIndex = -1
                                    this.waitTime = 61;
                                }
                            }, 1000);
                            notification.success({
                                message: '验证码发送成功，请查看手机短信',
                                style: {
                                    width: '400px',
                                    fontWeight: '600',
                                    marginLeft: `${-200}%`,
                                    marginTop: `${20}%`,
                                }
                            });
                        }
                        if (res.code == '1') {
                            notification.error({
                                message: '验证码发送失败，请稍后重新发送',
                                style: {
                                    width: '400px',
                                    fontWeight: '600',
                                    marginLeft: `${-200}%`,
                                    marginTop: `${20}%`,
                                }
                            });
                        }
                        if (res.code == '2') {
                            notification.warning({
                                message: res.msg,
                                style: {
                                    width: '400px',
                                    fontWeight: '600',
                                    marginLeft: `${-200}%`,
                                    marginTop: `${20}%`,
                                }
                            });
                        }
                        if (res.code == '3') {
                            this.$notification.error({
                                message: res.msg,
                                style: {
                                    width: '400px',
                                    fontWeight: '600',
                                    marginLeft: `${-200}%`,
                                    marginTop: `${20}%`,
                                }
                            });
                        }
                    })
                })
        },
        // 用户通过了验证
        success(msg) {
            this.isShow = false; // 通过验证后，需要手动隐藏模态框
            console.log('验证通过' + msg);
            this.verifyPhone()
        },
        // 用户点击遮罩层，应该关闭模态框
        close() {
            this.isShow = false;
        },
        // 用户验证失败
        fail() {
            console.log('验证失败');
        },
        subCompanyCode(){
            var valiSome = ['oraganizationCode']
            this.$refs.ruleForm.validate(valiSome).then(() => {
                this.getAction({
                        url: register_mp.getPhoneByLicence,
                        params: {
                            licence : this.form.oraganizationCode
                        }
                    }
                ).then((res) => {
                    console.log(res)
                    if (res) {
                        this.form.phoneNumber = res
                    } else {
                        this.$notification.error({
                            message: '该统一社会信用代码未注册，请先注册',
                            duration: 10,
                            style: {
                                width: '400px',
                                fontWeight: '600',
                                marginTop: `${10}%`,
                            },
                        });
                    }
                })
            })
        },
		getPhoneCode(){
			this.$refs.ruleForm
			.validate('phoneNumber')
				.then(() => {
					this.postAction({
						url: phoneCommon.retrievePwd,
						params: {
							licence: this.form.oraganizationCode
						}
					}
					).then((res) => {
						if (res.code == '0') {
							this.waitTime = (res.msg*60)+1
							this.waitTime--;
							// this.$refs.codeBtnWordMarkid.style.zIndex = 1
							this.codeBtnWord = `${this.waitTime}s 后获取`;
							let timer = setInterval(() => {
								if (this.waitTime > 1) {
									this.waitTime--;
									this.codeBtnWord = `${this.waitTime}s 后获取`;
								} else {
									clearInterval(timer);
									this.codeBtnWord = "获取短信验证码";
									// this.$refs.codeBtnWordMarkid.style.zIndex = -1
									this.waitTime = 61;
								}
							}, 1000);
							notification.success({
								message: '验证码发送成功，请查看手机短信',
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						}else if (res.code == '1') {
							notification.error({
								message: '验证码发送失败，请稍后重新发送',
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						} else if (res.code == '2') {
							notification.warning({
								message: res.msg,
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						} else if (res.code == '3') {
							notification.error({
								message: res.msg,
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						}
					})
				})
		},
		getCode() {

			this.$refs.ruleForm
				.validate('phoneNumber')
				.then(() => {
					this.postSeed()
					// this.waitTime--;
					// this.$refs.codeBtnWordMarkid.style.zIndex = 1
					// this.postSeed()
					// this.codeBtnWord = `${this.waitTime}s 后获取`;
					// let timer = setInterval(() => {
					// 	if (this.waitTime > 1) {
					// 		this.waitTime--;
					// 		this.codeBtnWord = `${this.waitTime}s 后获取`;
					// 	} else {
					// 		clearInterval(timer);
					// 		this.codeBtnWord = "获取邮箱验证码";
					// 		this.$refs.codeBtnWordMarkid.style.zIndex = -1
					// 		this.waitTime = 61;
					// 	}
					// }, 1000);
				})
				.catch(() => {
				})
    },

		postSeed() {
			this.$refs.ruleForm
				.validate('phoneNumber')
				.then((values) => {
					this.confirmLoading = true;
					this.postAction({
						url: common.sendCode,
						params: {
							mobilePhone: values.phoneNumber,
						}
					}
					).then((res) => {
						if(res.code=='0'){
							notification.success({
								message: '验证码发送成功，请查看邮箱',
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						}else if(res.code=='1'){
							notification.error({
								message: '邮箱不存在，请联系平台管理员补充邮箱',
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						}else if(res.code=='2'){
							notification.warning({
								message: '今日验证码已达上限，24小时后重新申请',
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						}else if(res.code=='3'){
							notification.warning({
								message: '邮箱功能未开通，联系管理员设置',
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						}else if(res.code=='4'){
							notification.error({
								message: res.msg,
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						}
						this.confirmLoading = false;
						// this.$router.push(this.redirectPath);
					}).catch((err) => {
						console.log(err, 'err')
						this.confirmLoading = false;
					})
				})
				.catch(() => {
				})
		},

		getNew(e) {
			if (e.target.value != this.form.newpassword) {
				this.pwOk = false
			} else {
				this.pwOk = true
			}
		},
    islogin() {
      if (ls.get("token") && ls.get("refresh_token")) {
        if (ls.get("roleCode").includes('company')) {
          this.goMore('/sys/companyInfo')
        } else if (ls.get("roleCode").includes('technicalManager')) {
          this.goMore('/sys/technology/person');
        } else {
          this.goMore('/sys/userInfo')
        }
      } else {
        this.goMore('/login', 'user')
      }
    },
		logout() {
			let self = this;

			self.$ls.clear();
			self.$store.commit('setMenuData', []);
			self.$router.replace('/');

			location.reload();
		},
		onLogout() {
			let self = this;
			self.$confirm({
				title: '确认要退出登录?',
				content: '',
				onOk() {
					self.postAction({
						url: login_mp.saveLog,
						params: { logAppCategoryEnum: "LOGOUT" }
					}).then(res => {
						console.log(res)
						self.getAction({
							url: login_mp.logout,
							params: { access_token: ls.get("token") || "" },
							isValid: false
						}).then(() => {
							self.$notification['success']({
								message: '退出成功',
								style: {
									fontWeight: '600',
								},
							});
						})
					})


					setTimeout(() => {
						self.logout();
					}, 2000)
				},
				onCancel() {
				},
			});
		},
		getUserInfo() {
			this.getAction({
				url: sys_admin.userInfor
			}).then(res => {
				sessionStorage.setItem("roleCode", res.roleCode.split(','));
			})
		},
		goMore(url, str) {
			this.$router.push({ path: url, query: { id: str } })
		},
		getImg(imgUrl) {
			return file_service.imagesWeb(imgUrl)
		},

		subPhone() {
			var valiSome = ['phoneNumber']
			this.$refs.ruleForm.validate(valiSome).then(() => {
				this.getAction({
					url: register_mp.verifyUniquePhone,
					params: {
						phoneNumber: this.form.phoneNumber
					}
				}
				).then((res) => {
					if (res) {
						this.$notification.error({
							message: '该手机号未注册！',
							duration: 10,
							style: {
								width: '400px',
								fontWeight: '600',
								marginTop: `${10}%`,
							},
						});
					} else {
						this.getPhoneCode()
						this.$notification.success({
							message: ('手机号可用，请继续操作！'),
							duration: 10,
							style: {
								width: '400px',
								fontWeight: '600',
								marginTop: `${10}%`,
							},
						});
					}
				})
			})
		},


		onSubmit() {

			if (this.pwOk == true) {
				if (this.showerror == false && this.show == false) {
			this.$refs.ruleForm
				.validate()
				.then((values) => {
					this.confirmLoading = true;
					this.postAction({
						url: (this.$route.query.id=='1'? common.submitMailCode : common.submitOtherPwd),
						params: {
							mobilePhone: values.phoneNumber,
							code: values.watmal,
							pwd: values.password,
						}
					}
					).then((res) => {
						if(res){
							notification.success({
								message: '密码已修改，请重新登录',
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
							this.goMore('/login','user')
						}else{
							notification.error({
								message: '验证码有误，请重新获取',
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						}

						this.confirmLoading = false;
						// this.$router.push(this.redirectPath);
					}).catch((err) => {
						console.log(err, 'err')
						this.confirmLoading = false;
					})
				})
				.catch(() => {
				})
			}
		} else {

				this.$notification.warning({
                                message: '密码输入有误！',
                                style: {
                                fontWeight: '600',
                                },
                            });
			}

		},

	},
	mounted() {
		this.all_logo = this.$ls.get('all_logo');
	},
	beforeCreate() {
		// 修改背景色
		document.querySelector('body').setAttribute('style', 'background-color:#fff')
	}
	,
	beforeUnmount() {
		// 销毁背景色
		document.querySelector('body').removeAttribute('style')
	},
}
</script>

<style scoped lang="less">
:deep(.ant-input),
:deep(.ant-input-affix-wrapper),
:deep(.ant-select:not(.ant-select-customize-input) .ant-select-selector){
    background: #f7f9fc;
    border:none;
}
.codeBtnWordMark{
	width: 100%;
	height: 40px;
	background: rgba(136, 135, 135, 0.6);
	position: absolute;
	left: 0;
	top: 0;
	z-index: -1;
}
.headerBox {
	width: 100%;
	height: 92px;
	background-color: #fff;

	.hearderContentBox {
		width: 1200px;
		margin: 0 auto;

		.titleBox {
			cursor: pointer;
			overflow: hidden;
			float: left;
			line-height: 92px;
			font-size: 30px;
			font-weight: bold;

			.logoBox {
				float: left;
				width: 73px;
				height: 66px;
				margin-right: 5px;

				img {
					width: 100%;
					height: 100%;
				}
			}
		}

		.rightBox {
			float: right;
			display: flex;
			justify-content: space-around;
			line-height: 92px;
			font-size: 16px;

			a {
				font-weight: 600;
			}

			.loginBox {
				// float: left;
				cursor: pointer;
			}

			.loginBox:hover {
				color: #fc550b;
			}

			.lineBox {
				height: 18px;
				top: 36px;
			}

			.resigierBox {
				cursor: pointer;
				// float: left;
			}

			.resigierBox:hover {
				color: #fc550b;
			}
		}
	}
}

.bannerBox {
	position: relative;
	width: 100%;

	:deep(.ant-carousel) {
		position: relative;
		width: 100%;
	}

	.bannerImg {
		width: 100%;
		height: 282px;

		img {
			width: 100%;
			object-fit: cover;
			height: 280px;
		}
	}
}



.floatBox {
	width: 100%;

	.textBox {
		width: 100%;
		height: 600px;
        background-image: url('../../assets/home/login-bj.png');
        background-size: 100% 100%;
        line-height: 40px;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        justify-content: center;

		.text {
            font-size: 40px;
            color: #fff;
            font-weight: 700;
            padding-top:100px;
		}
	}

	.midBox {
		position: relative;
		width: 100%;
		min-height: 50vh;

		.midFloatBox {
			overflow: hidden;
			width: 1200px;
			height: 100%;
			padding: 18px 15px 25px;
			margin: -420px auto 40px auto;
			background-color: #fff;
			box-shadow: 0 10px 15px rgba(39, 69, 167, .2);
			border-radius: 5px;

			.breadBox {
				// width: 1200px;
				margin: 3px 0 15px;
				font-size: 16px;
			}

			.tabBox {
				overflow: hidden;
				width: 100%;
				min-height: calc(100vh - 400px);
				margin: 0 auto;

				.code {
					text-align: center;
					height: 30px;
					background: #e2e2e2;
					line-height: 30px;
					font-size: 24px;
				}

				.layout-header {
					background-color: #ffffff;
					height: auto;
					padding-top: 30px;
				}

				//
				//.layout-content {
				//  background: url(../assets/img/login-bg.png) center center no-repeat #ffffff;
				//  padding: 60px 0;
				//}

				.layout-footer {
					background-color: #ffffff;
				}

				.container {
					//width: 90%;
					//height: 80%;
					margin-left: auto;
					margin-right: auto;
					padding-top: 30px;
					//padding-top: 48%;
					//background: url(../assets/img/login-image.png) center center no-repeat;
					//background-size: 80%;

				}

				.login-form {
					width: 70%;
					margin: 40px auto;

					h3 {
						margin: 0 0 30px;
						position: relative;
						padding-left: 15px;

						span {
							position: absolute;
							left: 0;
							display: block;
							height: 60%;
							top: 20%;
							width: 4px;
							background: #1890ff;
						}
					}

					.btnBB {
						width: 300px;
						margin: 0 auto;
					}

					:deep(.ant-form-item-label > label) {
						font-size: 16px;
					}
				}

				.ant-col-10 {
					margin-top: -43%;
					margin-left: 12%;
				}

				.title {
					font-size: 60px;
					font-weight: 500;
					margin: 40px 0;
				}



				.vcode-img {
					display: block;
					width: 100%;
					height: 50px;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.login-img {
					display: block;
					width: 100%;
				}

			}
		}

	}
}

.footerBox {
	width: 100%;
	background-color: #333333;

	.footerContent {
		position: relative;
		margin: 0 auto;
		padding: 24px 0;
		width: 1200px;

		.firstLine {
			padding: 8px 0;
			font-size: 14px;
			color: #999;

			span {
				margin-right: 18px;
			}
		}

		.footCode {
			position: absolute;
			right: 0;
			bottom: 12%;
			text-align: center;

			.footEwm {
				margin-bottom: 8px;
			}

			.footEwmTitle {
				color: #999;
			}
		}
	}
}

:deep(.ant-list-lg .ant-list-item) {
	padding: 16px 8px;
}
</style>
